import { use, useEffect } from "react";

import { NavigationContext } from "./use-navigation";

export function useKeyboard() {
  const { nextPage, prevPage, page, totalPages } = use(NavigationContext)!;

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target instanceof HTMLSelectElement
      ) {
        return;
      }

      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
        case " ":
          if (page < totalPages - 1) {
            e.preventDefault();
            nextPage();
          }
          break;
        case "ArrowLeft":
        case "ArrowUp":
          if (page > 0) {
            e.preventDefault();
            prevPage();
          }
          break;
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [nextPage, prevPage, page, totalPages]);
}
